import styled from "styled-components";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { project24 } from "../../content/project24";

const Page = styled.div`
  min-height: 100vh;
  background: ${p => p.theme.colors.homeNavy};
  color: ${p => p.theme.colors.homeText};
  padding: clamp(28px, 6vw, 72px) 24px 80px;
  a { color: ${p => p.theme.colors.accent}; }
  a:focus-visible { outline: 2px solid ${p => p.theme.colors.homeGold}; outline-offset: 5px; }
`;
const Content = styled.div`max-width: 1000px; margin: 0 auto;`;
const Header = styled.header`
  margin: 40px 0;
  p { color: ${p => p.theme.colors.accent}; letter-spacing: .12em; font-size: .8rem; text-transform: uppercase; }
  h1 { color: ${p => p.theme.colors.homeGold}; font-family: ${p => p.theme.fonts.heading}; font-size: clamp(2rem, 5vw, 3.5rem); line-height: 1.2; margin-top: 14px; }
`;
const ProjectArtwork = styled.img`
  display: block; width: 100%; height: auto; object-fit: contain; margin-bottom: 40px;
`;
const Preview = styled.section`
  background: ${p => p.theme.colors.homeSurface};
  border: 1px solid ${p => p.theme.colors.accent};
  border-radius: 8px;
  padding: clamp(24px, 4vw, 40px);
  margin-bottom: 48px;
  h2 { color: ${p => p.theme.colors.homeGold}; font-size: clamp(1.2rem, 3vw, 1.6rem); line-height: 1.5; margin-bottom: 16px; }
  p { line-height: 1.7; margin: 8px 0 0; }
`;
const Status = styled.span`
  display: inline-block; color: ${p => p.theme.colors.accent};
  font-size: .85rem; letter-spacing: .03em;
`;
const Catalogue = styled.section`
  h2 { color: ${p => p.theme.colors.homeGold}; font-size: 1.6rem; margin-bottom: 24px; }
  ol { list-style: none; padding: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 32px; }
  li { display: block; padding: 0 0 20px; border-bottom: 1px solid ${p => p.theme.colors.homeSurface}; line-height: 1.5; min-width: 0; }
  .cover { width: 100%; aspect-ratio: 3 / 2; object-fit: contain; display: block; background: #071c20; margin-bottom: 16px; }
  .missing-cover { display: grid; place-items: center; color: inherit; }
  .caption { display: flex; gap: 16px; align-items: baseline; }
  .number { flex: 0 0 2ch; font-size: .85rem; color: ${p => p.theme.colors.accent}; font-variant-numeric: tabular-nums; }
  .title { color: ${p => p.theme.colors.homeText}; overflow-wrap: anywhere; }
  @media (max-width: 640px) { ol { grid-template-columns: 1fr; } }
`;

export default function Project24() {
  return <Page><Content>
    <Helmet><title>Project 24: The Return | The Music Church</title><meta name="description" content="Project 24: The Return. Explore the 24-title catalogue from Ministry Before Industry." /></Helmet>
    <Link to="/ministries/ministry-before-industry">← Back to MBI</Link>
    <Header><p>Ministry Before Industry</p><h1>{project24.title}</h1></Header>
    <ProjectArtwork src={project24.cover} alt="Project 24: The Return — project cover" />
    <Preview aria-labelledby="introduction-title">
      <ProjectArtwork src="/images/project24/introduction-samuel.png" alt="Introduction Preview — Samuel with a golden scene reflected in his eye" loading="lazy" />
      <h2 id="introduction-title">{project24.introduction}</h2>
      <Status>Preview access coming</Status><p>The introduction preview is not available here yet.</p>
    </Preview>
    <Catalogue aria-labelledby="catalogue-title">
      <h2 id="catalogue-title">The 24 titles</h2>
      <ol>{project24.tracks.map((title, index) => <li key={title}>{project24.covers[index + 1] ? <img className="cover" src={project24.covers[index + 1]} alt={`${title} — working cover artwork`} loading="lazy" decoding="async" /> : <div className="cover missing-cover">Cover to be confirmed</div>}<div className="caption"><span className="number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span><span className="title">{title}</span></div></li>)}</ol>
    </Catalogue>
  </Content></Page>;
}
